import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class PinModel extends ModeModelBase {
  override _name = 'pin';
  override idAttribute = 'id';
  override belongsTo = 'account';
  override parentIdAttribute = 'username';

  override attributes = [
    { name: 'pinner_id' },
    { name: 'pinned_id' },
    { name: 'pinned_type' },
    { name: 'board_id' },
    { name: 'board_type' },
  ];

  override hasOne: [{ name: 'report'; idAttribute: 'token' }];
}

@Injectable({ providedIn: 'root' })
export class PinModelAccessor extends ModelAccessorBase<PinModel> {
  override name = 'pin';
  override idAttribute = 'id';
  override parentModel = 'account';
  override parentIdAttribute = 'username';
  override createAttributes = ['account'];

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.pin');
  }

  createModel(resource, opts?) {
    const model = new PinModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
}
